<template>
  <div class="helpcenter">

    <div class="mianb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">华章书院</el-breadcrumb-item>

        <el-breadcrumb-item>帮助中心</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="monbel">
      <checkimg
        v-for="(ien, idm) in helpListL"
        :key="idm"
        :ien="ien"
        :isShow="isShow"
      />
    </div>

    <foo-ter />
  </div>
</template>

<script>
import checkimg from "./centerChild.vue";
import fooTer from "../../components/footer";
export default {
  data() {
    return {
      activeNames: ["1"],
      isShow: true,
      helpListL: [
        {
          title: "一、普通用户如何选购：",
          heid: false,
          content:
            "成为VIP用户可免费阅读2000余种全书电子书、免费收听全部有声读物。VIP可根据用户需要按时段选购，订购季度VIP、半年VIP或一年VIP。",
          id: 1,
        },
        {
          title: "二、VIP用户可享受哪些免费服务？：",
          heid: false,
          content:
            "成为VIP用户可免费阅读2000余种全书电子书、免费收听全部有声读物。VIP可根据用户需要按时段选购，订购季度VIP、半年VIP或一年VIP。",
          id: 2,
        },
        {
          title: "三、华章鲜读是什么产品？：",
          heid: false,
          content:
            "成为VIP用户可免费阅读2000余种全书电子书、免费收听全部有声读物。VIP可根据用户需要按时段选购，订购季度VIP、半年VIP或一年VIP。",
          id: 3,
        },
        {
          title: "四、采购鲜读专栏可获取哪些“抢鲜”特权？：",
          heid: false,
          content:
            "成为VIP用户可免费阅读2000余种全书电子书、免费收听全部有声读物。VIP可根据用户需要按时段选购，订购季度VIP、半年VIP或一年VIP。",
          id: 4,
        },
        {
          title: "五、订购鲜读专栏有哪些须知？：",
          heid: false,
          content:
            "1. 内容保证作者在写作过程中会对图书目录结构进行不断调整和优化，“ 鲜读” 会及时更新； 出版社在出版过程中会对电子书内容进行进一步修改和优化， 不能确保电子书内容与纸书内容完全一致。2. 关于定价鲜读专栏的价格不等于纸书的定价， 但会以纸书的预估价格为参考。 ",
          id: 5,
        },
      ],
    };
  },
  methods: {
    handleshow(index) {
      this.isShow = !this.isShow;
    },
  },
  components: {
    fooTer,
    checkimg,
  },
};
</script>

<style lang="scss">
.helpcenter {
  width: 100%;
  background: #f7f7f7;
  min-width: 1157px;
  min-height: 965px;
  cursor: default;
  .top {
    width: 70px;
    height: 70px;
    background: #000000;
    border-radius: 8px;
    opacity: 0.19;
    display: flex;
    align-items: center;
    border: 1px solid red;
    .divg {
      width: 32px;
      height: 18px;
      margin: 0 auto;
    }
  }
  .topNav {
    width: 100%;
    height: 173px;
    border: 1px solid #fff;
    background: #fff;
    position: relative;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);

    .hovers {
      width: 221px;
      height: 506px;

      z-index: 20;
      position: absolute;
      right: 290px;
      top: 90px;
      background: #fff;

      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
      display: none;
      .vipmoy {
        width: 180px;
        height: 20px;

        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        margin-top: 14px;
        .viplo {
          width: 34px;
          height: 15px;
        }
        .spanv {
          width: 65px;
          height: 20px;
          font-size: 14px;
          font-weight: 500;
          color: #e6544c;
        }
      }
      .names {
        width: 171px;
        height: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0 auto;
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        margin-top: 8px;
      }
      .times {
        width: 123px;
        height: 20px;
        margin-left: 22px;
        margin-top: 9px;
        font-size: 14px;
        font-weight: 500;
        color: #999999;
      }
      .fenge {
        width: 179px;
        height: 1px;
        background: #eeeeee;
        margin: 0 auto;
        margin-top: 18px;
        margin-bottom: 18px;
      }
      .fosnam {
        width: 179px;
        height: 100px;
        // border: 1px solid red;
        margin: 0 auto;
        border-bottom: 1px solid #eeeeee;

        p {
          width: 76px;
          height: 25px;
          font-size: 18px;
          font-weight: 500;
          color: #333333;
          line-height: 25px;
          letter-spacing: 1px;
          margin-top: 20px;
        }
      }
      .fonbot {
        width: 179px;
        height: 190px;
        // border: 1px solid;
        margin: 0 auto;
        border-bottom: 1px solid #eeeeee;
        p {
          width: 76px;
          height: 25px;
          font-size: 18px;
          font-weight: 500;
          color: #333333;
          line-height: 25px;
          letter-spacing: 1px;
          margin-top: 20px;
        }
      }
      .nect {
        width: 179px;
        height: 57px;
        margin: 0 auto;

        line-height: 57px;

        font-size: 18px;
        font-weight: 500;
        color: #333333;
      }
    }
    .logipt {
      width: 1157px;
      height: 60px;
      margin: 0 auto;
      margin-top: 27px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logoBox {
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .logo {
          width: 360px;
          height: 100%;
        }
        .inputs {
          width: 140px;
          height: 50px;
          background: #f7f7f7;
          border-radius: 25px;
          margin-left: 30px;
          text-align: center;
          font-size: 20px;
          line-height: 50px;
          display: flex;
          align-items: center;
          img {
            width: 22px;
            height: 22px;
            margin-left: 22px;
            margin-right: 18px;
          }
          span {
            font-size: 21px;
            font-weight: 500;
            color: #c9c9c9;
          }
        }
      }
      .logins {
        width: 95px;
        height: 29px;
        font-size: 21px;
        font-weight: 500;
        color: #e6564e;
      }
      .users {
        width: 210px;
        height: 47px;

        display: flex;
        align-items: center;
        justify-content: space-between;
        div {
          font-size: 21px;
          font-weight: 600;
          color: #e6564e;
          line-height: 25px;
          width: 130px;
          height: 25px;
          // border: 1px solid red;
          border-right: 3px solid #d8d8d8;
        }
      }
    }
    .tablistBg {
      width: 100%;
      background: white;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .topNavShow {
      position: fixed !important;
      z-index: 99 !important;
      top: 0 !important;
      // left: 0 !important;
      // left: calc((100% - 1157px) / 2) !important;
      background: white;
      margin-top: 0 !important;
      // width: calc(100% - 15px);
      width: 100%;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    }
    .tablist {
      height: 70px;
      width: 1157px;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
      align-items: center;
      font-size: 21px;
      font-weight: 400;
      color: #bdbdbd;
      position: relative;
      margin-top: 0px !important;
      .tabActive {
        font-size: 24px;
        font-weight: 500;
        color: #e6564e !important;
        padding-bottom: 5px;
        // border: 1px solid red;
        text-align: center;

        display: flex;
        justify-content: center;
      }
      .tabActive2 {
        margin-left: 0;
      }
      .unTabActive2 {
        margin-left: -6px;
      }
      .tabActive::before {
        content: "";
        width: 40px;
        border-radius: 5px;
        height: 3px;
        position: absolute;
        text-align: center !important;
        // border-bottom: 4px solid #e6564e;
        background-color: #e45754;
        display: block;
        bottom: 0;
      }
    }
    .tablist:hover {
      cursor: pointer;
    }
  }
  .mianb {
    width: 1157px;
    height: 75px;
    // border: 1px solid red;
    margin: 0 auto;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
    color: #363636;
    .el-breadcrumb {
      font-size: 16px;
    }
    .el-breadcrumb__item:last-child .el-breadcrumb__inner {
      color: #e6554d !important;
    }
  }
  .monbel {
    width: 1157px;
    border: 1px solid #fff;
    background: #fff;
    min-height: 470px;
    margin: 0 auto;
    padding-bottom: 60px;
  }
}
</style>
